(function () {
  'use strict';
  if (window.__timbaAnalyticsChoice) return;
  window.__timbaAnalyticsChoice = true;
  function start() {
    if (!document.getElementById('timba-cookie-mobile-style')) {
      var style = document.createElement('style');
      style.id = 'timba-cookie-mobile-style';
      style.textContent = "@media (max-width: 749px) {\n  #shopify-pc__banner { padding: 12px !important; width: 100% !important; max-width: none !important; margin: 0 !important; left: 0 !important; right: 0 !important; box-sizing: border-box !important; }\n  #shopify-pc__banner .shopify-pc__banner__wrapper { display: flex !important; flex-direction: column !important; gap: 8px !important; }\n  #shopify-pc__banner .shopify-pc__banner__body { margin: 0 !important; }\n  #shopify-pc__banner #shopify-pc__banner__body-title { font-size: 16px !important; line-height: 1.3 !important; margin: 0 0 4px !important; }\n  #shopify-pc__banner .timba-cookie-detail { display: none !important; }\n  #shopify-pc__banner .timba-cookie-mobile { display: block !important; font-size: 13px !important; line-height: 1.4 !important; margin: 0 !important; }\n  #shopify-pc__banner .shopify-pc__banner__btns { display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; gap: 6px !important; margin: 0 !important; }\n  #shopify-pc__banner .shopify-pc__banner__btns button:not([aria-hidden=\"true\"]) { width: auto !important; min-width: 0 !important; min-height: 48px !important; margin: 0 !important; padding: 6px 4px !important; font-size: 12px !important; line-height: 1.3 !important; white-space: normal !important; }\n}\n@media (min-width: 750px) { #shopify-pc__banner .timba-cookie-mobile { display: none !important; } }";
      document.head.appendChild(style);
    }
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      var privacy = window.Shopify.customerPrivacy;
      if (error || !privacy || !privacy.setTrackingConsent) return;
      function enhance() {
        var banner = document.getElementById('shopify-pc__banner');
        if (!banner || banner.querySelector('#timba-accept-analytics')) return;
        var accept = banner.querySelector('#shopify-pc__banner__btn-accept');
        var paragraph = banner.querySelector('.shopify-pc__banner__body p');
        var policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
        if (!accept || !paragraph || !policy) return;
        var button = document.createElement('button');
        button.id = 'timba-accept-analytics';
        button.type = 'button';
        button.className = accept.className;
        button.textContent = 'Accept analytics only';
        var status = document.createElement('p');
        status.setAttribute('role', 'status');
        status.hidden = true;
        function fail() {
          button.disabled = false;
          status.textContent = 'Your choice could not be saved. Please try again or select Choose cookies.';
          status.hidden = false;
        }
        button.addEventListener('click', function () {
          button.disabled = true;
          status.hidden = true;
          try {
            privacy.setTrackingConsent({ analytics: true, marketing: false, preferences: false, sale_of_data: false }, function (result) {
              if (result && result.error) { fail(); return; }
              var saved = privacy.currentVisitorConsent();
              if (saved.analytics !== 'yes' || saved.marketing !== 'no' || saved.preferences !== 'no') { fail(); return; }
              banner.style.display = 'none';
              button.disabled = false;
            });
          } catch (_) { fail(); }
        });
        var decline = banner.querySelector('#shopify-pc__banner__btn-decline');
        if (decline) decline.textContent = 'Essential cookies only';
        paragraph.replaceChildren(document.createTextNode('We use essential cookies to run the shop. With your permission, analytics records how you browse and interact so we can improve your shopping experience. See Choose cookies for details and our '), policy, document.createTextNode('.'));
        paragraph.classList.add('timba-cookie-detail');
        var mobileParagraph = document.createElement('p');
        mobileParagraph.className = 'timba-cookie-mobile';
        var mobilePolicy = policy.cloneNode(true);
        mobilePolicy.removeAttribute('id');
        mobileParagraph.append(document.createTextNode('Essential cookies keep the shop working. Analytics is optional. Choose cookies for details. '), mobilePolicy, document.createTextNode('.'));
        paragraph.after(mobileParagraph, status);
        accept.before(button);
        accept.style.display = 'none';
        accept.setAttribute('aria-hidden', 'true');
      }
      enhance();
      new MutationObserver(enhance).observe(document.body, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();